import { Reveal } from "./motion";

// Left-aligned editorial section heading with eyebrow + optional index
export const SectionHeading = ({ eyebrow, title, subtitle, light = false, align = "left" }) => (
  <div className={`max-w-2xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    {eyebrow && (
      <Reveal>
        <p className="eyebrow mb-5">{eyebrow}</p>
      </Reveal>
    )}
    <Reveal delay={0.08}>
      <h2
        className={`font-serif font-light text-4xl sm:text-5xl md:text-6xl leading-[1.02] tracking-tight ${
          light ? "text-white" : "text-navy"
        }`}
      >
        {title}
      </h2>
    </Reveal>
    {subtitle && (
      <Reveal delay={0.16}>
        <p className={`mt-6 text-base md:text-lg leading-relaxed font-light ${light ? "text-white/70" : "text-darkgray/70"}`}>
          {subtitle}
        </p>
      </Reveal>
    )}
  </div>
);
